<template id="additional__fields">
  <div class="additional-fields d-none">
    <div @click="showFieldList" :class="showAdditionalFields ? 'active' : ''" class="add-field-btn cursor-pointer">
        <img class="exclude-outside-click" src="@/csmworkflow/img/plus.svg" />
    </div>
    <div v-click-outside="outside" v-show="showAdditionalFields" class="fields">
        <h3>Fields</h3>
        <div class="d-flex">
            <div class="field-items cursor-pointer" @click="newField('user')">
                <i class="fas fa-users"></i> User
            </div>
            <div class="field-items cursor-pointer" @click="newField('status')">
                <i class="fas fa-info-circle"></i> Status
            </div>
            <div class="field-items cursor-pointer" @click="newField('status_note')">
                <i class="fas fa-comments"></i> Long Text
            </div>
            <div class="field-items cursor-pointer" @click="newField('due_date')">
                <i class="fas fa-calendar"></i> Datepicker
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    props: [
        'deliverableType', 'deliverableId', 'namespace'
    ],
    data() {
        return {
            showAdditionalFields: false
        }
    },
    methods: {
        ...mapActions({
            createNewField(dispatch, payload) {
                return dispatch(this.namespace + 'createNewField', payload)
            },
            updateTaskData(dispatch, payload) {
                return dispatch(this.namespace + 'updateTaskData', payload)
            },
        }),
        showFieldList() {
            this.showAdditionalFields = !this.showAdditionalFields
        },
        newField(fieldKey) {
            let self = this
            this.createNewField({
                fieldKey: fieldKey,
                deliverableType: this.deliverableType,
                deliverableId: this.deliverableId
            }).then((deliverableData) => {
                self.showAdditionalFields = false
                self.addFieldToUi(deliverableData.data.deliverableData, self.deliverableId)
            })
        },
        addFieldToUi(deliverableData, deliverableId) {
            this.$store.commit(this.namespace + 'updateTaskData', {deliverableData, deliverableId})
            this.$store.commit(this.namespace + 'groupUserDeliverable')
        },
        outside() {
            this.showAdditionalFields = false
        }
    }
}
</script>

<style>

</style>
